import React, { useState, useEffect } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { AppSidebar, AppFooter, AppHeader } from "./index";
import { CContainer } from "@coreui/react";
import RightSidebar from "./RightSidebar";
import AlertNotification from "./globals/AlertNotification";
import { jwtDecode } from "jwt-decode";

const ProtectedRoute = ({
  role: requiredRole,
  managerOnly = false,
  staffOrManagerOnly = false,
  requireClaim,
}) => {
  const [rightSidebarOpen, setRightSidebarOpen] = useState(false);
  const [sidebarContent, setSidebarContent] = useState(null);
  const location = useLocation();

  const accessToken = localStorage.getItem("access_token");
  const refreshToken = localStorage.getItem("refresh_token");
  const currentRole = localStorage.getItem("role") || "";
  let is_manager = false;
  let is_staff = false;
  let hasRequiredClaim = !requireClaim;
  const redirectPath = `${location.pathname}${location.search}${location.hash}`;
  const loginPath = `/login?redirect=${encodeURIComponent(redirectPath)}`;

  useEffect(() => {
    setRightSidebarOpen(false);
    setSidebarContent(null);
  }, [location.pathname]);

  const now = Math.floor(Date.now() / 1000);
  let hasValidSession = false;

  try {
    if (!accessToken) throw new Error("Missing access token");
    const decodedAccessToken = jwtDecode(accessToken);
    if (decodedAccessToken?.exp && decodedAccessToken.exp > now) {
      is_manager = !!decodedAccessToken.is_manager;
      is_staff = !!decodedAccessToken.is_staff;
      if (requireClaim) {
        hasRequiredClaim = !!decodedAccessToken[requireClaim];
      }
      hasValidSession = true;
    }
  } catch (error) {
    // Ignore and fallback to refresh token validation.
  }

  if (!hasValidSession) {
    try {
      if (!refreshToken) throw new Error("Missing refresh token");
      const decodedRefreshToken = jwtDecode(refreshToken);
      if (!decodedRefreshToken?.exp || decodedRefreshToken.exp <= now) {
        throw new Error("Expired refresh token");
      }
      is_manager = !!decodedRefreshToken.is_manager;
      is_staff = !!decodedRefreshToken.is_staff;
      if (requireClaim) {
        hasRequiredClaim = !!decodedRefreshToken[requireClaim];
      }
      hasValidSession = true;
    } catch (error) {
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      localStorage.removeItem("role");
      return <Navigate to={loginPath} state={{ from: location }} replace />;
    }
  }

  if (!hasValidSession) {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("role");
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  // Se a rota requer um papel específico e o usuário não tem, redireciona para "/"
  if (
    (requiredRole && currentRole !== requiredRole) ||
    (managerOnly && !is_manager) ||
    (staffOrManagerOnly && !(is_manager || is_staff)) ||
    !hasRequiredClaim
  ) {
    return <Navigate to="/" replace />;
  }

  const setSidebar = (visible, content) => {
    if (visible) {
      setSidebarContent(content);
    }
    setRightSidebarOpen(visible);
  };

  const fluidPages = [
    "/analise-concorrencia",
    "/acoes-inovacao",
    "/projetos-idi",
    "/acoes-melhoria",
    "/ponderacoes-avaliacao-fornecedores",
    "/ponderacoes-avaliacao-desempenho",
  ];

  const isFluid = fluidPages.includes(location.pathname);

  return (
    <>
      <AppSidebar />

      <div className="wrapper d-flex flex-column min-vh-100">
        <AppHeader />

        <CContainer className="d-flex flex-grow-1 pb-5 protected-layout-shell" fluid>
          {/* <div className="d-flex"> */}
          <CContainer
            fluid={isFluid}
            className={`${rightSidebarOpen ? "col-8 me-0" : "col-12"} protected-layout-main`}
          >
            <AlertNotification />
            <Outlet context={{ setSidebar }} />
          </CContainer>

          <RightSidebar isOpen={rightSidebarOpen}>
            {sidebarContent}
          </RightSidebar>
          {/* </div> */}
        </CContainer>

        <AppFooter />
      </div>
    </>
  );
};

export default ProtectedRoute;
